// Shared company-config cache. One fetch per page load, all components read from it.
import { useEffect, useState } from 'react';
import { companyAPI } from './api';

let _cache = null;
let _inflight = null;

export function loadCompany() {
  if (_cache) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = companyAPI.get()
    .then((res) => { _cache = res.data; _inflight = null; return _cache; })
    .catch((err) => { _inflight = null; throw err; });
  return _inflight;
}

export function getCachedCompany() {
  return _cache;
}

export function useCompany() {
  const [company, setCompany] = useState(_cache);
  useEffect(() => {
    if (!_cache) {
      loadCompany().then(setCompany).catch(() => setCompany(null));
    }
  }, []);
  return company;
}
